import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

function TermsAndConditions() {
  return (
    <div id="layoutDefault_content">
      <div id="layoutDefault">
        <div id="layoutDefault_content">
          <main>
            <Navbar />
            <section
              className="bg-white py-10 mt-10"
              style={{ fontFamily: "Lato" }}
            >
              <div className="container md:px-15 px-5">
                <h2 className="mb-4">Terms & Conditions</h2>
                <p className="lead">
                  By accessing and using this website, you agree to follow our
                  terms of use. The content on this site is provided for general
                  informational purposes and may be updated without notice. All
                  materials are the property of CenSyn, Inc. and may not be
                  copied, reproduced, or redistributed without prior written
                  permission. Continued use of the site indicates acceptance of
                  these terms.
                </p>
              </div>
            </section>
          </main>
        </div>

        <Footer />
      </div>
    </div>
  );
}

export default TermsAndConditions;
